import { render } from "./etBtn.vue?vue&type=template&id=67afc6af"
import script from "./etBtn.vue?vue&type=script&lang=js"
export * from "./etBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__